import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DirectDebitService } from '../../../services/directDebitService';

const directDebitService = new DirectDebitService();

export const SignWithUaePassButton = ({ mandateId, returnUrl, size = 'small', ...buttonProps }) => {
	const { t } = useTranslation();

	const handleSignMandate = async () => {
		try {
			const urlToUse = returnUrl ?? window.location.href;
			const response = await directDebitService.getUaePassSignerUrl(mandateId, urlToUse);
			const url = response?.data?.url;
			if (url) {
				window.open(url, '_blank', 'noopener,noreferrer');
			}
		} catch (error) {
			console.error('Error getting signer URL:', error);
		}
	};

	return (
		<Button
			variant="contained"
			color="primary"
			onClick={handleSignMandate}
			size={size}
			{...buttonProps}
		>
			{t('Sign with UAE Pass')}
		</Button>
	);
};
